import styled from "styled-components";

export const CMWizardModalStep = styled.div((props) => ({
  padding: props.theme.spacers["5"],  
  overflow: props.isContract ? "auto" : "" ,

  "&::-webkit-scrollbar": {
    width: "8px",
  },

  "&::-webkit-scrollbar-track": {
    backgroundColor: "white",
  },

  "&::-webkit-scrollbar-thumb": {
    borderRadius: "6px",
    backgroundColor: props.theme.palette.primary.main,
  },
  

  "& h2": {
    flex:1,
    textAlign: "center",
    margin: props.theme.spacers["5"],
    marginTop: 0,
    paddingBottom: "1rem",
    fontFamily: props.theme.fontFamilies.workSans,
    borderBottom: `solid 1px ${props.theme.palette.primary.main}`,
    fontWeight: "normal",
  },
  [`@media (max-height: 992px)`]: {
    overflow: "none"
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    width: "100% !important",
    paddingLeft:0,
    paddingRight:0,
  },

  "& .wizardStep-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "& .wizardStep-closeButton": {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "25px",
    color: "#333",
    marginRight: "0",
    marginTop:"-15px",
    },
  },

}));


